(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name productes.llista.controller:LlistaCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.llista')
    .controller('ProductesMainLlistaCtrl', ProductesMainLlistaCtrl);

  function ProductesMainLlistaCtrl($translate,$rootScope,$scope, HelperFactory, Notification, ProducteFactory, $window, $state, $stateParams,llistaaplicacions) {
    var vm = this;
    vm.ctrlName = 'ProductesMainLlistaCtrl';

    vm.calculateListFields = calculateListFields;
    vm.load = load;
    vm.view = view;
    vm.edit=edit;
    vm.deleteProductes=deleteElem;
    vm.duplicate = duplicate;

    vm.llista = [];
    vm.page = 1;
    vm.perPage = 25;
    vm.pages = 0;
    vm.canLoad = true;
    vm.errors=[];
    vm.auxaplicaciosel=[];

    vm.issuperadmin= $rootScope.issuperadmin;

    vm.cercaObj = {
      page : vm.page,
      perPage: vm.perPage,
      pages: vm.pages,
      nom: '',
      aplicaciosel:[],
      idaplicacio:''
    };


    if (!angular.isUndefined(llistaaplicacions)){
      vm.listallaplicacio=llistaaplicacions.data.list;
    }

    function onChangeFunction(){
      vm.cercaObj.idaplicacio=null;
      if (vm.cercaObj.aplicaciosel!=null){
        if (vm.cercaObj.aplicaciosel.length>0){
          vm.cercaObj.idaplicacio=vm.cercaObj.aplicaciosel[0].id;
        }
      }
    }

    if ($rootScope.issuperadmin){
      vm.formulari = {
        nom: 'cercador',
        func: function(){
          cercar();
        },
        camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              columns: 6,
              required: false
            }
            ,
            {
                type: 'chips',
                name: 'aplicaciosel',
                list:vm.listallaplicacio,
                master: true,
                fieldProperty: 'nom',
                textPlaceholder: $translate.instant('APLICACIO_CERCA'),
                columns: 6,
                label:"CERCA_APLICACIONS",
                onChange :  onChangeFunction,
                mdMaxChips:2
            }
          ]
        }
      }
      else
      {
      vm.formulari = {
        nom: 'cercador',
        func: function(){
          cercar();
        },
        camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              columns: 6,
              required: false
            }]
        }
      }

    function loadProductes() {
      if (!angular.isUndefined($rootScope.permisos) && $rootScope.permisos.PRODUCTE.read){
       vm.auxaplicaciosel=vm.cercaObj.aplicaciosel;
        vm.cercaObj.aplicaciosel=[];
        var promise = ProducteFactory.getAll(vm.cercaObj).then(function(response){
          $scope.$evalAsync(function(){
            vm.cercaObj.pages = response.data.pages;
            vm.cercaObj.page = response.data.page + 1;
            angular.forEach(response.data.list, function(entrada) {
              vm.llista.push(entrada);
            });
          });
        }).catch(function(error){
          Notification.processError(error);
        });
        vm.cercaObj.aplicaciosel=vm.auxaplicaciosel;
        return promise;
      }
      else
      {
        return undefined;
      }
    }

    function cercar(){
      vm.cercaObj.page = 1;
      vm.cercaObj.pages = undefined;
      vm.llista = [];
      loadProductes();
    }

    function load(){
      if (!angular.isUndefined(vm.cercaObj.pages) && (vm.cercaObj.page < (vm.cercaObj.pages + 1)) ) {
        vm.canLoad = false;
        loadProductes().then(function(){
          $scope.$evalAsync(function(){
            vm.canLoad = true;
          });
        });
      }
    }

    function calculateListFields(reductedList){
      if (reductedList){
        vm.fields = [
          {
            header: 'DEFAULT_NOM',
            type: 'text',
            name: 'nom'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];
      } else{
        vm.fields = [
          {
            header: 'DEFAULT_NOM',
            type: 'text',
            name: 'nom'
          },
          {
            header: 'DEFAULT_APLICACIO',
            type: 'text',
            name: 'nomaplicacio'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];

      }
    }

    function deleteElem(id) {
      $rootScope.$broadcast('$activateLoader');
      ProducteFactory.delete(id).then(function(response){
        $scope.$evalAsync(function(){
          vm.llista.forEach(function(elem, index) {
            if (elem.id === id){
                vm.llista.splice(index,1);
                vm.indexeliminat=index;
            }
          });
          if (vm.llista.length==0 )
          {
            HelperFactory.setParams($stateParams, {'idProducte': null});
            $state.go('productes.main', $stateParams, {'reload': 'productes.main.submain'});
          }
          else
          {
            if (vm.llista.length==1)
            {
              view(vm.llista[0]);
            }
            else{
              if (vm.indexeliminat<vm.llista.length)
              {
                view(vm.llista[vm.indexeliminat]);
              }
              else
              {
                view(vm.llista[vm.indexeliminat-1]);
              }
            }
          }

        });
      $rootScope.$broadcast('$deactivateLoader');
      }).catch(function(error){
        $rootScope.$broadcast('$deactivateLoader');
        Notification.processError(error);
      });
    }




    function duplicate(id){
      $rootScope.$broadcast('$activateLoader');
      ProducteFactory.duplicate(id).then(function(response){
        cercar();
        $rootScope.$broadcast('$deactivateLoader');
      }).catch(function(error){
        $rootScope.$broadcast('$deactivateLoader');
        Notification.processError(error);
      });
    }

    function edit(id) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'isNew': false, 'idProducte': id});
      $state.go('productes.main.submain.edit', $stateParams, {'reload': 'productes.main.submain'});
    }

    function view(obj) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'idProducte': obj.id});
      $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain'});
    }

    $scope.$on('addItemToTree', function(event, data) {
      HelperFactory.setParams($stateParams, {'isNew': true, 'idProducte': undefined});
      $state.go('productes.main.submain.edit', $stateParams);
    });

    cercar();

    /*--------------------------------EVENTS ------------------------------*/

    $scope.$on('changeSides', function(event, data) {
      vm.calculateListFields(!data.left.collapsed && !data.links.collapsed);
    });

    $scope.$on('productes.main.delete', function(event, data) {
      deleteElem(data.id);
    });

     $scope.$on('productes.main.edit', function(event, data) {
      edit(data.id);
    });


    $scope.$on('productes.main.llista.update', function(event, data) {
      vm.llista.forEach(function(obj, index){
        if (obj.id === data.id) {
          obj.nom = data.nom;

          if (obj.nom.indexOf(vm.cercaObj.nom) == -1) {
            vm.llista.splice(index, 1);
          }
          Notification.success('GENERIC_SUCCESS');

          return;
        }
      });
    });

    $scope.$on('productes.main.llista.add', function(event, data) {
      $stateParams.idProducte = data.id;
        if (vm.cercaObj.idaplicacio== data.aplicacio.id ||vm.cercaObj.idaplicacio==null ||vm.cercaObj.idaplicacio=="" ){
          if (data.nom.indexOf(vm.cercaObj.nom) != -1 )  {
          vm.llista.push(data);
          }
        }

      view(data);
      Notification.success('GENERIC_SUCCESS');
    });

    if (angular.isUndefined($stateParams.idProducte)){
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
    }

  }
}());
